import { languageService } from "../../../Language/language.service";

export const ReservationSchema = {
  title: languageService("Create Reservation"),
  id: "ReservationSchema",
  stateTitle: {
    Add: languageService("Create Reservation"),
  },
  sections: [
    {
      id: "ReservationInfo",
      col: 12,
      fields: [
        {
          id: "workOrderId",
          type: "select",
          labelValue: languageService("MR#"),
          selectOptions: [],
          required: true,
          col: 6,
          updatedSectionFieldsOnCertainValue: [{ targetSecId: "ReservationItems", getSectionFieldsCallback: "onMRChange" }],
        },
        {
          id: "warehouseCode",
          type: "select",
          labelValue: languageService("Warehouse"),
          selectOptions: [],
          required: true,
          col: 6,
        },
        {
          id: "status",
          type: "input",
          labelValue: languageService("Status"),
          col: 6,
          hide: true,
        },
      ],
    },
    {
      id: "ReservationItems",
      col: 12,
      fields: [],
    },
    {
      id: "footerArea",
      col: 12,
      fields: [
        {
          id: "submitData",
          type: "button",
          labelValue: languageService("Create"),
          action: "submit",
          callback: "onSubmit",
          position: "footer",
          col: 6,
        },
        {
          id: "closeDialog",
          type: "button",
          labelValue: languageService("Cancel"),
          action: "cancel",
          callback: "closeModal",
          position: "footer",
          col: 6,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/IMS/Reservation/ReservationSchema.js